// extracted by mini-css-extract-plugin
module.exports = {"chat":"Chat_chat__2KXQY","people":"Chat_people__GzEqG","chatting":"Chat_chatting__3AwRV","headerPeople":"Chat_headerPeople__3_gyl","peopleBody":"Chat_peopleBody__2Dbiv"};